/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_BrokerSsoConfigurationKeyDto } from '../models/PagedResultDto_BrokerSsoConfigurationKeyDto';
import type { Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationKeyDto } from '../models/Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationKeyDto';
import type { Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto } from '../models/Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrokerSsoConfigurationKeyService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppBrokerSsoConfigurationKey(
requestBody?: Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/broker-sso-configuration-key',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityApiAppBrokerSsoConfigurationKey(
id: string,
requestBody?: Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/app/broker-sso-configuration-key/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationKeyDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppBrokerSsoConfigurationKey(
id: string,
): CancelablePromise<Wealthlane_Dtos_SsoProvider_BrokerSsoConfigurationKeyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/broker-sso-configuration-key/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiAppBrokerSsoConfigurationKey(
id: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/app/broker-sso-configuration-key/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param brokerSsoConfigurationId 
     * @param effectiveFrom 
     * @param expiresAt 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_BrokerSsoConfigurationKeyDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppBrokerSsoConfigurationKeyByConfigurationId(
brokerSsoConfigurationId: string,
effectiveFrom?: string,
expiresAt?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_BrokerSsoConfigurationKeyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/broker-sso-configuration-key/by-configuration-id/{BrokerSsoConfigurationId}',
            path: {
                'BrokerSsoConfigurationId': brokerSsoConfigurationId,
            },
            query: {
                'EffectiveFrom': effectiveFrom,
                'ExpiresAt': expiresAt,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
